import { z } from "zod";

export const ZAkustikkProsjektinfoSchema = z.object({
  fase: z.object({
    skisseForprosjekt: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    totalenterprisegrunnlag: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    detaljprosjekt: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    rehabilitering: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
  }),
  vedlegg: z.object({
    lydtegninger: z.object({
      isActive: z.boolean().default(true),
      text: z.string(),
    }),
    tabellEllerTekst: z.object({
      isActive: z.boolean().default(true),
      text: z.string(),
      tabellGrenseverdier: z.object({
        text: z.string(),
        isActive: z.boolean().default(false),
      }),
      henvisningVedlegg: z.object({
        text: z.string(),
        isActive: z.boolean().default(false),
      }),
    }),
  }),
  typeBygg: z.object({
    bolig: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
      flerFamiliehus: z.object({
        isActive: z.boolean().default(false),
        text: z.string(),
      }),
    }),
    undervisningsbygg: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    barnehage: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    helsebygg: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    omsorgsboliger: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    hotell: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    kontorbygg: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    kulturbygg: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    idrettsbygg: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    butikk: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    produksjonsbygg: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    restaurant: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    treningsrom: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
  }),
  konstruksjonstype: z.object({
    lette: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    tunge: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    massivtre: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
    heis: z.object({
      isActive: z.boolean().default(false),
      text: z.string(),
    }),
  }),
});

export type IAkustikkProsjektinfo = z.infer<typeof ZAkustikkProsjektinfoSchema>;
